import { render, staticRenderFns } from "./DialogAppBar.vue?vue&type=template&id=0fe4c272&scoped=true"
import script from "./DialogAppBar.vue?vue&type=script&lang=js"
export * from "./DialogAppBar.vue?vue&type=script&lang=js"
import style0 from "./DialogAppBar.vue?vue&type=style&index=0&id=0fe4c272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4c272",
  null
  
)

export default component.exports